import { type ColorTokenMode, getColorTokens } from './tokens';
import type { AlertColor } from '@mui/material';

const buildUiTokens = (
  mode: ColorTokenMode,
): {
  statusColors: {
    neutral: string;
    green: string;
    red: string;
    orange: string;
    brown: string;
    teal: string;
    purple: string;
    pink: string;
    blue: string;
  };
} => {
  const colorTokens = getColorTokens(mode);
  return {
    statusColors: {
      neutral: colorTokens.neutral,
      green: colorTokens.green,
      red: colorTokens.red,
      orange: colorTokens.orange,
      brown: colorTokens.brown,
      teal: colorTokens.teal,
      purple: colorTokens.purple,
      pink: colorTokens.pink,
      blue: colorTokens.blue,
    },
  } as const;
};

export type UiTokens = ReturnType<typeof buildUiTokens>;

export const getUiTokens = (mode: ColorTokenMode): UiTokens => buildUiTokens(mode);

export const uiTokens = buildUiTokens('light');

export type UiTone = keyof typeof uiTokens.statusColors;

export const chartStatusDarkenCoefficient = 0.14;

export const uiToneSeverityMap: Record<UiTone, AlertColor> = {
  neutral: 'info',
  green: 'success',
  red: 'error',
  orange: 'warning',
  brown: 'warning',
  blue: 'info',
  purple: 'info',
  pink: 'info',
  teal: 'info',
};
